import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { growthbook } from '../growthbook';
import PosthogService from '../services/posthog/PosthogService';
import { getPosthogConfig } from '../services/posthog/config';
import { posthogIdentifyIfChanged } from '../utils/posthog/identify';

/**
 * Starts PostHog once, and tells PostHog and GrowthBook who the signed-in
 * admin is whenever that changes. Forgetting the admin on sign-out is the
 * session teardown's job (`useSessionTeardown`).
 */
export const useAnalyticsIdentity = () => {
  const adminUser = useSelector((state) => state.users.adminUser);

  useEffect(() => {
    PosthogService.getInstance().initialize(getPosthogConfig());
  }, []);

  useEffect(() => {
    if (!adminUser?.id) return;
    if (posthogIdentifyIfChanged(adminUser)) {
      PosthogService.getInstance().waitForFlagReload();
    }
    growthbook.setAttributes({ ...growthbook.getAttributes(), id: adminUser.id });
    // A refetched record is a new object; identify only re-sends when its fields changed.
  }, [adminUser]);
};

export default useAnalyticsIdentity;
